// extracted by mini-css-extract-plugin
module.exports = {"blackTile":"PianoKey_blackTile__y8-HJ","whiteTile":"PianoKey_whiteTile__3QnQk","tile":"PianoKey_tile__25jdw"};